import { render, staticRenderFns } from "./editApply.vue?vue&type=template&id=5bfd8a95&scoped=true&"
import script from "./editApply.vue?vue&type=script&lang=ts&"
export * from "./editApply.vue?vue&type=script&lang=ts&"
import style0 from "./editApply.vue?vue&type=style&index=0&id=5bfd8a95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfd8a95",
  null
  
)

export default component.exports